import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';
import { PriceTargetItem, StockHaltStatus } from '../../shared/models';

@Injectable({
  providedIn: 'root'
})
export class PriceVolumeMoversService extends RmsBasicCrudService<PaginatedList<PriceTargetItem>> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets the Movers Price Data
   * Common params: TYPE: string, egt: number, elt: number
   * @param params
   * @returns {Observable<PaginatedList<PriceTargetItem>>}
   */
  public getStockHalts (params?: any): Observable<PaginatedList<PriceTargetItem>> {
    return super.getData('/api/rms/stockhalts', params);
  }

  /**
   * Gets the status of the stock halts as a whole, which currently means whether any has yet to
   * resume. Served separately from the halts page because halts are ordered with the current ones
   * first, so a page after the first cannot show any.
   * @returns {Observable<StockHaltStatus>}
   */
  public getStockHaltStatus (): Observable<StockHaltStatus> {
    return this.getHttp().get<StockHaltStatus>('/api/rms/stockhalts/status')
      .pipe(catchError(ex => this.getExceptions().catchBadResponse(ex)));
  }

  /**
   * Gets the Movers Price Data
   * Common params: TYPE: string, egt: number, elt: number
   * @param params
   * @returns {Observable<PaginatedList<PriceTargetItem>>}
   */
  public getMoversPrice (params?: any): Observable<PaginatedList<PriceTargetItem>> {
    return super.getData('/api/rms/movers/price', params);
  }

  /**
   * Gets the Movers Volume Data
   * Common params: TYPE: string, egt: number, elt: number
   * @param params
   * @returns {Observable<PaginatedList<PriceTargetItem>>}
   */
  public getMoversVolume (params?: any): Observable<PaginatedList<PriceTargetItem>> {
    return super.getData('/api/rms/movers/volume', params);
  }

  /**
   * Gets the Movers Price Offhours Data
   * Common params: TYPE: string, egt: number, elt: number
   * @param params
   * @returns {Observable<PaginatedList<PriceTargetItem>>}
   */
  public getMoversPriceOffhours (params?: any): Observable<PaginatedList<PriceTargetItem>> {
    return super.getData('/api/rms/movers/price/offhours', params);
  }

    /**
   * Gets the price high Data
   * Common params: TYPE: string, egt: number, elt: number
   * @param params
   * @returns {Observable<PaginatedList<PriceTargetItem>>}
   */
    public getMoversHigh (params?: any): Observable<PaginatedList<PriceTargetItem>> {
      return super.getData('/api/rms/movers/price/high', params);
    }

      /**
     * Gets the price low Data
     * Common params: TYPE: string, egt: number, elt: number
     * @param params
     * @returns {Observable<PaginatedList<PriceTargetItem>>}
     */
      public getMoversLow (params?: any): Observable<PaginatedList<PriceTargetItem>> {
        return super.getData('/api/rms/movers/price/low', params);
      }
}
